import { type FC } from 'react';
import { StyleSheet, View, type StyleProp, type ViewStyle } from 'react-native';
import Colors from 'src/core/utils/Colors';
import Fonts from 'src/core/utils/Fonts';
import Dimens from 'src/core/utils/Dimens';
import type { Format } from 'react-native-barcoder';
import BarcodeView from 'react-native-barcoder';

const DEFAULT_BAR_HEIGHT = Dimens.size100;

interface Props {
	barcode: string;
	format: Format;
	barHeight?: number;
	style?: StyleProp<ViewStyle>;
}

const Barcode: FC<Props> = ({ barcode, format, barHeight = DEFAULT_BAR_HEIGHT, style }) => {
	return (
		<View style={styles.parentContainer}>
			<View style={[styles.contentContainer, style]}>
				<BarcodeView
					options={{ format, font: Fonts.barlow, fontSize: Dimens.fontSize14, height: barHeight }}
					value={barcode}
				/>
			</View>
		</View>
	);
};

const styles = StyleSheet.create({
	parentContainer: {
		backgroundColor: Colors.white,
	},
	contentContainer: {
		color: Colors.white,
		justifyContent: 'center',
		alignItems: 'center',
		padding: Dimens.padding20,
		borderBottomLeftRadius: Dimens.borderRadius10,
		borderBottomRightRadius: Dimens.borderRadius10,
	},
});

export default Barcode;
